import React, { Component } from 'react'
import {
  Container,
  Header,
  Segment,
  Image
} from 'semantic-ui-react'

class Usage extends Component {
	
    constructor(props) {
        super(props)

    }

    render() {  
        return(
            <Segment textAlign='center' style={{  minHeight: 700, padding: '1em 0em' }} vertical>
                <Container textAlign='left' style={{marginBottom: '4em',marginTop: '4em'}} text>
                    <Header as='h1' content='How to use'/>
                    <Header as='h3' content='Get Wallet'/>
                    <p>	
                        First of all you should get a unique identificator. It calls a wallet because you can put money into it.
                    </p>
                    <p>
                        <Image src='assets/usage/1.jpg' size='big' centered />
                    </p>
                    <p>	
                        Then you should save your wallet. You can download a file or copy a seed. <strong>Don't show it to anyone!</strong> Because knowing it someone can take your money.
                    </p>
                    <p>
                        <Image src='assets/usage/2.jpg' size='big' centered />
                    </p>
                    <Header as='h3' content='Get Ether'/>
                    <p>	
                        To make any transaction in Ethereum blockchain you should have some Ether. Since we use Rinkeby Tesnet you can get it for free by Rinkeby Authenticated Faucet.
                    </p>
                    <p>
                        <Image src='assets/usage/3.jpg' size='big' centered />
                    </p>
                    <p>	
                        You can request funds via Twitter, Google Plus or Facebook. You should create a public post with your wallet address embedded into the content.
                    </p>
                    <p>
                        <Image src='assets/usage/4.jpg' size='large' centered/>
                        <Image src='assets/usage/5.jpg' size='large' centered/>
                    </p>
                    <p>
                        Then copy-paste the posts URL into input field and choose how much Ether you want.
                    </p>
                    <p>
                        <Image src='assets/usage/6.jpg' size='big' centered />
                    </p>
                    <p>
                        Wait while request will be processed. Then you should refresh a page and you can see that you have Ether in your wallet.
                    </p>
                    <p>
                        <Image src='assets/usage/7.jpg' size='big' centered />
                    </p>
                    <Header as='h3' content='Become a Citizen'/>
                    <p>
                        Then you should become a citizen of the city. Enter your name and click Submit.
                    </p>
                    <p>
                        <Image src='assets/usage/8.jpg' size='big' centered />
                    </p>
                    <p>
                        Enter your wallet password and click Submit.
                    </p>
                    <p>
                        <Image src='assets/usage/9.jpg' size='big' centered />
                    </p>
                    <p>
                        Then you can see your transaction hash. 
                    </p>
                    <p>
                        <Image src='assets/usage/10.jpg' size='big' centered />
                    </p>
                    <p>
                        You can click on it and you will see all details about your transaction.
                    </p>
                    <p>
                        <Image src='assets/usage/11.jpg' size='big' centered />
                    </p>
                    <p>
                        Wait while transaction will be confirmed. Then update a page and you will see that you should pay some fee. All citizens pay taxes. You should put some value and create transaction.
                    </p>
                    <p>
                        <Image src='assets/usage/12.jpg' size='big' centered />
                    </p>
                    <p>
                        Also there is a Token page where you can buy or sell a token. Token allows you to create proposals, execute them and vote. Citizen could have only one token. Also you can return it in any moment.
                    </p>
                    <p>
                        <Image src='assets/usage/13.jpg' size='big' centered />
                    </p>
                    <p>
                        So, welcome to the city. 
                    </p>
                    <p>
                        <Image src='assets/usage/14.jpg' size='big' centered />
                    </p>
                    <p>
                        To create a new proposal click + Proposal. You can write something about a problem that should be resolved. Enter minimum votes, minutes for voting, recipient (optional) and fee that will be used from the city budget (optional).
                    </p>
                    <p>
                        <Image src='assets/usage/15.jpg' size='big' centered />
                    </p>
                    <p>
                        After submitting your proposal will be visible to all citizens.
                    </p>
                    <p>
                        <Image src='assets/usage/16.jpg' size='big' centered />
                    </p>
                </Container>
            </Segment>
        )	
    }		
}


export default Usage


// WEBPACK FOOTER //
// ./src/layouts/usage/Usage.js